import { RESET_NOTIFICATION_ALERTS, UPDATE_NOTIFICATION_ALERTS } from "./actionTypes";
import * as Yup from "yup";

const notificationAlertBase = {
    id: '',
    config_id: '',
    user_default: false,
    company_administrator: false,
    email: false,
    sokets: false,
    sms: false,
    action_id: '',
    company_id: '',
    extra_users: []
}

const initialState = {
    notification_alert: { ...notificationAlertBase },
    validations: {

    }
};

const notificationAlert = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_NOTIFICATION_ALERTS:
            // Actualizar el estado
            return {
                ...state,
                notification_alert: action.payload
            };
        case RESET_NOTIFICATION_ALERTS:
            return {
                ...state,
                notification_alert: { ...notificationAlertBase }
            };
        default:
            return state;
    }
};

export default notificationAlert;
